import Header from "@/models/header";

export default class Response {
  dateCreated?: string;
  contentHeaders?: Array<Header>;
  errorReasonPhrase?: string;
  httpMethod?: string;
  isValidSSL?: string;
  responseHeaders?: Array<Header>;
  statusCode: number;
  reasonPhrase?: string;
  targetUrl?: string;
  responseTime?: number;
  requestedUrl?: string;

  get headers(): Array<Header> {
    if (this.contentHeaders && this.responseHeaders) {
      return [...this.contentHeaders, ...this.responseHeaders];
    }

    return [];
  }

  constructor(rawResponse: any) {
    if (rawResponse.dateCreated) {
      this.dateCreated = rawResponse.dateCreated;
    }

    if (rawResponse.contentHeaders) {
      this.contentHeaders = rawResponse.contentHeaders;
    }

    if (rawResponse.errorReasonPhrase) {
      this.errorReasonPhrase = rawResponse.errorReasonPhrase;
    }

    if (rawResponse.httpMethod) {
      this.httpMethod = rawResponse.httpMethod;
    }

    if (rawResponse.isValidSSL) {
      this.isValidSSL = rawResponse.isValidSSL;
    }

    if (rawResponse.responseHeaders) {
      this.responseHeaders = rawResponse.responseHeaders;
    }

    if (rawResponse.statusCode) {
      this.statusCode = rawResponse.statusCode;
    } else {
      this.statusCode = -1;
    }

    if (rawResponse.reasonPhrase) {
      this.reasonPhrase = rawResponse.reasonPhrase;
    }

    if (rawResponse.targetUrl) {
      this.targetUrl = rawResponse.targetUrl;
    }

    if (rawResponse.responseTime) {
      this.responseTime = rawResponse.responseTime;
    }

    if (rawResponse.requestedUrl) {
      this.requestedUrl = rawResponse.requestedUrl;
    }
  }
}
